import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { ListContainer } from 'components';
import SGPCompany from './SGPCompany';
import SGPCompaniesTable from './SGPCompaniesTable';

const SGPCompanies = () => {
    return (
        <ListContainer>
            <Routes>
                <Route path="create" element={<SGPCompany />} />
                <Route path="edit/:id" element={<SGPCompany />} />
                <Route index exact element={<SGPCompaniesTable />} />
                <Route path="*" element={<Navigate to="/sgp-companies" replace />} />
            </Routes>
        </ListContainer>
    );
};

export default SGPCompanies;
